import * as React from 'react';
import styled, { css } from 'styled-components';
import { TextArea } from '@progress/kendo-react-inputs';
import { Error, FloatingLabel } from '@progress/kendo-react-labels';
import colors from '../shared/colors';

const Container = styled.fieldset`
  ${props => props.$width && css`
    flex-grow: 0;
    flex-basis: auto;
    width: ${props.$width};
  `}
`;

const CharacterCounter = styled.span`
  display: block;
  margin-top: 4px;
  text-align: right;
  font-size: 12px;
  color: ${props => props.$exceeded ? colors.ERROR_50 : colors.GRAY_60};
`;

const Textarea = (props) => {
  const { valid, validationMessage, width, label, characterLimit, ...rest } = props;
  const valueLength = props.value ? props.value.length : 0;
  const textarea = (
    <TextArea
      {...rest}
      valid={valid}
      validationMessage={validationMessage}
    />
  );

  return (
    <Container $width={width} className={'k-form-fieldset'}>
      {label
        ?
        <FloatingLabel
          label={label}
          labelClassName='k-label'
          editorId={props.id}
          editorValue={props.value}
          editorValid={valid}
          editorDisabled={props.disabled}
          editorPlaceholder={props.placeholder}
        >
          {textarea}
        </FloatingLabel>
        : textarea
      }
      {characterLimit > 0 &&
        <CharacterCounter $exceeded={valueLength > characterLimit}>
          {`${valueLength} / ${characterLimit}`}
        </CharacterCounter>
      }
      {!valid && <Error>{validationMessage}</Error>}
    </Container>
  );
};

export default Textarea;
